/**
 * Monta a query string da busca a partir dos filtros que vivem na URL.
 *
 * Existe separado da SearchPage para poder ser testado como funcao pura: a
 * regra que interessa aqui — parametro vazio NAO entra — e a diferenca entre
 * `/api/produtos?search=&marketplace=` e uma requisicao limpa.
 *
 * O nome do parametro muda de proposito entre a URL do site e a da API: a
 * pagina usa `q`, porque e o que o usuario ve e compartilha, e a API usa
 * `search`, que ja era o contrato de `/api/produtos` antes desta rodada.
 * `marketplace` tem o mesmo nome dos dois lados.
 */
export function montaBuscaParams({ q = '', marketplace = '' } = {}) {
    const params = new URLSearchParams();
    const termo = (q || '').trim();
    const loja = (marketplace || '').trim();
    if (termo) params.set('search', termo);
    if (loja) params.set('marketplace', loja);
    return params;
}

export default montaBuscaParams;
